import { render, staticRenderFns } from "./SliderGamesResult.vue?vue&type=template&id=f7cfecf0&"
import script from "./SliderGamesResult.vue?vue&type=script&lang=js&"
export * from "./SliderGamesResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports